import { UseQueryResult } from "@tanstack/react-query"
import {
  CpatAssessment,
  LearningCertificateData,
} from "api/resources/cpat/types"
import { APIResponse } from "api/types"
import React from "react"

type Context = {
  attempt: UseQueryResult<APIResponse<CpatAssessment> | undefined, unknown>
  reports: UseQueryResult<APIResponse<LearningCertificateData[]>, unknown>
}

export const defaultCpatContextValues: Context = {
  // @ts-expect-error this is safe to do
  attempt: {},
  // @ts-expect-error this is safe to do
  reports: {},
}

export const context = React.createContext<Context>(defaultCpatContextValues)
